import { IApplicationState } from '../../types/redux/store';

export const isAutorisationPopupOpenSelector = (state: IApplicationState): boolean => {
  return state.consultantCianChat.isAutorisationPopupOpened;
};
